<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				<img src="../../../assets/budget/fanhui.png" @click="Return"
					style="vertical-align: middle;margin-top: -2px;" />
				<!-- 预算管理-{{ title }} -->
				预算管理-修改
			</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="height:20px"></div>
				<div class="findcontent">
					<div class="findTitle">预算单</div>
					<div class="formlist">
						<el-form :inline="true" :model="formInline" class="demo-form-inline">
							<el-form-item label="预算单编号">
								<el-input v-model="formInline.budget_number" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="年度">
								<el-date-picker v-model="formInline.annual" type="year" value-format="yyyy" readonly
									placeholder="选择年" size="small" style="width:120px">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="项目名称">
								<el-input v-model="formInline.projectName" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="组织架构">
								<el-input v-model="formInline.group_structure" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="formInline.notes" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="制表人">
								<el-input v-model="formInline.tabulator" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div class="btnicon">
					<!-- <div class="btnview" @click="Save()">
						<img src="../../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">保存</span>
					</div> -->
					<div class="btnview">
						<img src="../../../assets/budget/提交审核.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;" @click="saveClick()">保存</span>
					</div>
					<div class="btnview">
						<img src="../../../assets/budget/导出.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">导出</span>
					</div>
				</div>

				<div class="tabs">
					<div>
						<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="预算汇总表" name="first">
								<div>
									<el-table :data="tableData" ref="multipleTable"
										:header-cell-style="{ background: '#d3eae2', color: '#000000' }"
										:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
										style="width: 100%" @cell-mouse-leave="cellMouseLeave" :key="changeKey"
										:summary-method="getSummaries" @cell-mouse-enter="cellMouseEnter" height="500"
										:cell-class-name="tableRowClassName">
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
										</el-table-column>
										<el-table-column prop="firstName" align="center" label="预算分类"></el-table-column>
										<!-- <el-table-column prop="secondaryName" align="center" label="预算名称"> -->
										<!-- </el-table-column> -->
										<el-table-column prop="accumulate_1" align="center" label="1月累计" v-if="month < 1">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_1" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_1 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_2" align="center" label="2月累计" v-if="month < 2">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_2" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_2 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_3" align="center" label="3月累计" v-if="month < 3">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_3" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_3 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_4" align="center" label="4月累计" v-if="month < 4">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_4" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_4 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_5" align="center" label="5月累计" v-if="month < 5">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_5" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_5 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_6" align="center" label="6月累计" v-if="month < 6">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_6" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_6 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_7" align="center" label="7月累计" v-if="month < 7">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_7" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_7 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_8" align="center" label="8月累计" v-if="month < 8">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_8" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_8 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_9" align="center" label="9月累计" v-if="month < 9">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_9" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_9 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_10" align="center" label="10月累计"
											v-if="month < 10">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_10" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_10 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_11" align="center" label="11月累计"
											v-if="month < 11">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_11" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_11 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_12" align="center" label="12月累计"
											v-if="month < 12">
											<template slot-scope="scope">
												<el-input v-model="scope.row.accumulate_12" v-if="scope.row.spare6 == 1"
													class="table" size="small"
													@change="updateDataThreee($event, index, scope.row)"
													style="width: 187px;" :readonly="readonly"></el-input>
												<span v-else>{{ scope.row.accumulate_12 }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="accumulate" align="center" label="合计"></el-table-column>
									</el-table>
								</div>
							</el-tab-pane>
							<el-tab-pane label="预算明细"> 
								<el-table :data="ruleForm.summary"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }"
									:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
									style="width: 100%" @cell-mouse-leave="cellMouseLeave" :key="changeKey"
									:summary-method="getSummaries" @cell-mouse-enter="cellMouseEnter" height="500"
									:cell-class-name="tableRowClassName">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="series" align="center" label="预算分类" width="150" fixed>
										<template slot-scope="scope">
											<span>{{ scope.row.first_name }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="secondary_name" align="center" label="预算名称" width="200" fixed>
									</el-table-column>
									<el-table-column prop="invoice_name" align="center" v-for="(item, index) in dateList"
										:key="index" width="150">
										<template slot="header" slot-scope="scope">
											<span>{{ item.monthly }}月月度预算</span>
										</template>
										<el-table-column align="center" label="在岗人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].employees_number"
													:readonly="readonly" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="倒休人数">
											<template slot-scope="scope" ref="loginForm">
												<el-input v-model="scope.row.outsideList[index].retroactive_rest"
													:readonly="readonly" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="合计人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].amount_number" size="small"
													:readonly="readonly"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="单人金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].individual_amount"
													:readonly="readonly" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="总金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].assemble_amount"
													:readonly="readonly" size="small"
													@keyup.enter.native="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
									</el-table-column>
								</el-table>
							</el-tab-pane>
							<el-tab-pane label="月度预算" v-if="List.annualExamine == '3' && List.monthlyExamine == '1'">
								<el-table :data="ruleForm.outside"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }"
									:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
									style="width: 100%" @cell-mouse-leave="cellMouseLeave" :key="changeKey"
									:summary-method="getSummaries" @cell-mouse-enter="cellMouseEnter" height="500"
									:cell-class-name="tableRowClassName">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="firstName" align="center" label="预算分类"></el-table-column>
									<el-table-column prop="secondaryName" align="center" label="预算名称">
									</el-table-column>
									<el-table-column prop="invoice_name" align="center">
										<template slot="header" slot-scope="scope">
											<span>{{ ruleForm.monthly }}月月度预算(修改前)</span>
										</template>
										<el-table-column prop="employees_number" align="center" label="在岗人数">
										</el-table-column>
										<el-table-column prop="retroactive_rest" align="center" label="倒休人数">
										</el-table-column>
										<el-table-column prop="amount_number" align="center" label="合计人数">
										</el-table-column>
										<el-table-column prop="individual_amount" align="center" label="单人金额">
										</el-table-column>
										<el-table-column prop="assemble_amount" align="center" label="总金额">
										</el-table-column>
									</el-table-column>

									<el-table-column prop="invoice_name" align="center">
										<template slot="header" slot-scope="scope">
											<span>{{ ruleForm.monthly }}月月度预算(修改后)</span>
										</template>
										<el-table-column align="center" label="在岗人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.formOutside.employees_number" size="small"
													@keyup.enter.native="updateDataTwo($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="倒休人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.formOutside.retroactive_rest" size="small"
													@keyup.enter.native="updateDataTwo($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="合计人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.formOutside.amount_number" size="small"
													@keyup.enter.native="updateDataTwo($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="单人金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.formOutside.individual_amount" size="small"
													@keyup.enter.native="updateDataTwo($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="总金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.formOutside.assemble_amount" size="small"
													@keyup.enter.native="updateDataTwo($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
									</el-table-column>
								</el-table>
							</el-tab-pane>
						</el-tabs>

					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	props: ["ruleForm", "title", "List"],
	data() {
		return {
			total: 0,
			activeName: 'first',
			tableData: [],
			ids: [],
			dateList: [],
			checkedCities: [],
			checkedbuds: [],
			dateLists: [],
			month: 1,
			// dateList: [{
			// 	monthly: 1
			// }, {
			// 	monthly: 2
			// }, {
			// 	monthly: 3
			// }, {
			// 	monthly: 4
			// }, {
			// 	monthly: 5
			// }, {
			// 	monthly: 6
			// }, {
			// 	monthly: 7
			// }, {
			// 	monthly: 8
			// }, {
			// 	monthly: 9
			// }, {
			// 	monthly: 10
			// }, {
			// 	monthly: 11
			// }, {
			// 	monthly: 12
			// }, ],
			//条件
			formInline: {},
			projectList: [],
			orderIndexArr: [],
			hoverOrderArr: [],
			readonly: false,

		};
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
			if (tab.name == 'first') {
				this.FindOne()
			}
		},
		async updateData(event, index, row) {
			var record = {
				first_id: row.outsideList[index].first_id,
				secondary_id: row.outsideList[index].first_id,
				monthly:index+1,
				budget_id: this.ruleForm.budget.id,
				employees_number: row.outsideList[index].employees_number,
				retroactive_rest: row.outsideList[index].retroactive_rest,
				amount_number: row.outsideList[index].amount_number,
				individual_amount: row.outsideList[index].individual_amount,
				assemble_amount: row.outsideList[index].assemble_amount,
			}
			var data = await this.$globals.AxiosPost('formOutside/add', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async updateDataTwo(event, index, row) {
			console.log(row)
			var record = {
				id: row.formOutside.id,
				budget_id: this.ruleForm.budget.id,
				employees_number: row.formOutside.employees_number,
				retroactive_rest: row.formOutside.retroactive_rest,
				amount_number: row.formOutside.amount_number,
				individual_amount: row.formOutside.individual_amount,
				assemble_amount: row.formOutside.assemble_amount,
			}
			var data = await this.$globals.AxiosPost('formSummary/updateOutside', record);
			if (data.code === '200') {
				if (event) {
					event.target.blur()
				}
				this.$message.success('修改成功！');
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async saveClick() {
			var data = await this.$globals.AxiosGet('formSummary/updateBudget?info=' + this.formInline.id);
			if (data.code === '200') {
				this.$message.success('操作成功！');
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async updateDataThreee(event, index, row) {
			console.log(event, index, row)
			var record = {
				budget_id: this.formInline.id,
				first_id: row.first_id,
				accumulate_1: row.accumulate_1,
				accumulate_2: row.accumulate_2,
				accumulate_3: row.accumulate_3,
				accumulate_4: row.accumulate_4,
				accumulate_5: row.accumulate_5,
				accumulate_6: row.accumulate_6,
				accumulate_7: row.accumulate_7,
				accumulate_8: row.accumulate_8,
				accumulate_9: row.accumulate_9,
				accumulate_10: row.accumulate_10,
				accumulate_11: row.accumulate_11,
				accumulate_12: row.accumulate_12,
			}
			var data = await this.$globals.AxiosPost('formSummary/updateSummary', record);
			if (data.code === '200') {
				// if (event) {
				// 	event.target.blur()
				// }
				this.$message.success('修改成功！');
				this.FindOne()
				this.$refs["loginForm"].$el[index + 1].focus();
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		Return() {
			this.$emit("return");
		},
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		//分页
		handleCurrentChange(val) {
			this.condition.page_num = val;
		},
		getOrderNumber() {
			const orderObj = {};
			this.tableData.forEach((item, index) => {
				item.rowIndex = index;
				if (orderObj[item.firstName]) {
					orderObj[item.firstName].push(index);
				} else {
					orderObj[item.firstName] = [];
					orderObj[item.firstName].push(index);
				}
			});
			// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
			Object.keys(orderObj).forEach((key) => {
				if (orderObj[key].length > 1) {
					this.orderIndexArr.push(orderObj[key]);
				}
			});
		},
		objectSpanMethod({
			row,
			column,
			rowIndex,
			columnIndex
		}) {
			if (columnIndex === 0 || columnIndex === 1) {
				for (let i = 0; i < this.orderIndexArr.length; i += 1) {
					let element = this.orderIndexArr[i];
					for (let j = 0; j < element.length; j += 1) {
						let item = element[j];
						if (rowIndex === item) {
							if (j === 0) {
								return {
									rowspan: element.length,
									colspan: 1,
								};
							}
							if (j !== 0) {
								return {
									rowspan: 0,
									colspan: 0,
								};
							}
						}
					}
				}
			}
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			let arr = this.hoverOrderArr;
			for (let i = 0; i < arr.length; i += 1) {
				if (rowIndex === arr[i]) {
					return 'hovered-row';
				}
			}
		},
		cellMouseEnter(row, column, cell, event) {
			this.rowIndex = row.rowIndex;
			this.hoverOrderArr = [];
			this.orderIndexArr.forEach((element) => {
				if (element.indexOf(this.rowIndex) >= 0) {
					this.hoverOrderArr = element;
				}
			});
		},
		cellMouseLeave(row, column, cell, event) {
			this.rowIndex = '-1';
			this.hoverOrderArr = [];
		},
	},
	async created() {
		console.log(this.ruleForm, '098765', this.title)
		this.formInline = this.ruleForm.budget;
		this.tableData = this.ruleForm.summaryList;
		this.dateList = this.ruleForm.ergodic
		this.month = this.ruleForm.month
		this.readonly = this.ruleForm.isNot
		this.getOrderNumber()
		console.log(this.month)

		var projectList = await this.$globals.AxiosPost("tenderHonourAgreement/getProjectList", {});
		this.projectList = projectList.data;
	},
};
</script>

<style scoped>
.dispp {
	display: flex;
	align-items: center;
}

.findcontent {
	border: 1px solid #006e4b;
	background-color: #fafff9;
	padding: 10px 20px;
	margin: 0 30px;
}

.findTitle {
	font-size: 18px;
	font-weight: 600;
	color: #006e4b;
	margin-top: 10px;
}

.formlist {
	margin-top: 10px
}

.btnicon {
	display: flex;
	margin: 20px 0 10px 10px;
}

.btnview {
	margin-left: 20px;
}

.tabs {
	margin: 0 30px;
}
</style>
<style>
.tabs .el-tabs--border-card>.el-tabs__header {
	background-color: #fafafa;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
	border-top: 3px solid #006e4b;
	font-size: 18px;
	border-right-color: #fff;
	border-left-color: #fff;
}

.tabs .el-tabs--border-card>.el-tabs__header {
	border: none;
}

.tabs .el-tabs--border-card {
	border: none
}

.tabs .el-tabs--border-card>.el-tabs__content {
	padding: 5px 0;
}

.tabs .el-tabs__item {
	font-size: 18px;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
	font-size: 18px;
}

.tabs .el-tabs__nav {
	height: 40px;
}</style>



// WEBPACK FOOTER //
// edit.vue?7beacfba